import { IAppAuthorizations, IUiAuthorizations } from './state';

export const isFetchingUiAuth = (state: { appUiAuth: IAppAuthorizations }): boolean => state.appUiAuth.isFetchingUiAuth;
export const getAppAuthContext = (state: { appUiAuth: IAppAuthorizations }): string => state.appUiAuth.appContext;
export const getRelaxedUiAuth = (state: { appUiAuth: IAppAuthorizations }): IUiAuthorizations | {} => state.appUiAuth.relaxedMode;
export const getStrictUiAuth = (state: { appUiAuth: IAppAuthorizations }): IUiAuthorizations | {} => state.appUiAuth.strictMode;
